import { Notification } from "@mantine/core";
import type { ReactNode } from "react";

interface PasswordNotificationProps {
  title: string;
  message: ReactNode;
  color: string;
  onClose: () => void;
}

/**
 * Reusable notification component for password change operations.
 * Handles display of success, error, and info messages with proper styling.
 */
export const PasswordNotification = ({
  title,
  message,
  color,
  onClose,
}: PasswordNotificationProps) => {
  return (
    <Notification
      title={title}
      color={color}
      onClose={onClose}
      withCloseButton
      styles={{
        root: { wordBreak: "break-word" },
        title: { wordBreak: "break-word" },
        description: { wordBreak: "break-word" },
      }}
    >
      {message}
    </Notification>
  );
};
